import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "report" }
const _hoisted_2 = { class: "tbdc-report-header" }
const _hoisted_3 = {
  key: 0,
  style: {"float":"right"},
  class: "tbdc-report-header-block"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 1,
  style: {"float":"right"},
  class: "tbdc-report-header-block"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "mb-0" }
const _hoisted_8 = { style: {"height":"400px","width":"100%","margin-bottom":"0em","pointer-events":"none"} }
const _hoisted_9 = { style: {"height":"400px","width":"100%","margin-bottom":"1em","pointer-events":"none"} }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "text-right" }
const _hoisted_12 = { class: "text-right" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { key: 2 }
const _hoisted_16 = { key: 3 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { key: 2 }
const _hoisted_19 = { key: 3 }
const _hoisted_20 = { class: "font-weight-thin" }
const _hoisted_21 = { style: {"height":"400px","width":"100%","margin-bottom":"1em"} }
const _hoisted_22 = { style: {"height":"400px","width":"100%","margin-bottom":"0em","pointer-events":"none"} }
const _hoisted_23 = { style: {"height":"400px","width":"100%","margin-bottom":"0em","pointer-events":"none"} }
const _hoisted_24 = { style: {"height":"400px","width":"100%","margin-bottom":"0em","pointer-events":"none"} }
const _hoisted_25 = { class: "text-right" }
const _hoisted_26 = { class: "text-right" }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { key: 1 }
const _hoisted_29 = { key: 2 }
const _hoisted_30 = { key: 3 }
const _hoisted_31 = { class: "font-weight-thin" }
const _hoisted_32 = { class: "font-weight-thin" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_Properties = _resolveComponent("Properties")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_Mapbox = _resolveComponent("Mapbox")!
  const _component_PropertyValue = _resolveComponent("PropertyValue")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_MatchingLocationsOutputChart = _resolveComponent("MatchingLocationsOutputChart")!
  const _component_MatchingLocationsRadarChart = _resolveComponent("MatchingLocationsRadarChart")!
  const _component_DriversChart = _resolveComponent("DriversChart")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: _ctx.localShow,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.localShow) = $event)),
    width: "21cm"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.location && _ctx.scenario && _ctx.model && _ctx.locationCatchmentArea)
          ? (_openBlock(), _createBlock(_component_v_card, {
              key: 0,
              id: "locationReport"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, { "primary-title": "" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                      _createElementVNode("h2", null, _toDisplayString(_ctx.$tc("message.locationsType" + _ctx.model.locationsType + "Name")) + " " + _toDisplayString(_ctx.$tc("message.report")), 1),
                      (_ctx.model.hasMainLogo)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                            (_ctx.model != null)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  src: '/api/models/' + _ctx.model.id + '/main-logo',
                                  class: "tbdc-report-header-image"
                                }, null, 8, _hoisted_4))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.model.hasSecondaryLogo)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            (_ctx.model != null)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  src: '/api/models/' + _ctx.model.id + '/secondary-logo',
                                  class: "tbdc-report-header-image"
                                }, null, 8, _hoisted_6))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [
                    _createElementVNode("section", null, [
                      _createElementVNode("h3", null, _toDisplayString(_ctx.location.name) + " (" + _toDisplayString(_ctx.scenario.name) + _toDisplayString(_ctx.subModel.name != 'Default'?' ' + _ctx.subModel.name:'') + ")", 1),
                      _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t("message.generatedOn")) + " " + _toDisplayString(_ctx.$filters.datetime(new Date(), _ctx.$i18n.locale)) + " " + _toDisplayString(_ctx.$t("message.by")) + " " + _toDisplayString(_ctx.account.name), 1)
                    ]),
                    (!_ctx.model.locationReportFormat)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createElementVNode("section", null, [
                            _createVNode(_component_v_container, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_row, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, {
                                      class: "pr-4",
                                      style: {"max-width":"50%"}
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_Properties, {
                                          subModel: _ctx.subModel,
                                          model: _ctx.model,
                                          location: _ctx.location,
                                          locationProperties: _ctx.locationProperties != null ? _ctx.locationProperties.filter(_ctx.selectViewLocation) : null
                                        }, null, 8, ["subModel", "model", "location", "locationProperties"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, {
                                      class: "pl-4",
                                      style: {"max-width":"50%"}
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_Properties, {
                                          subModel: _ctx.subModel,
                                          model: _ctx.model,
                                          location: _ctx.location,
                                          locationProperties: _ctx.locationProperties != null ? _ctx.locationProperties.filter(_ctx.selectViewLocationOutput) : null
                                        }, null, 8, ["subModel", "model", "location", "locationProperties"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("section", null, [
                            _createElementVNode("h4", null, _toDisplayString(_ctx.$t("message.localSituation")), 1),
                            _createElementVNode("div", _hoisted_8, [
                              _createVNode(_component_Mapbox, {
                                mapState: { zoom: 16 },
                                report: true,
                                refresh: _ctx.refresh,
                                locations: _ctx.locations,
                                scenario: _ctx.scenario,
                                model: _ctx.model,
                                location: _ctx.location,
                                onStartBusy: _ctx.startBusy,
                                onEndBusy: _ctx.endBusy
                              }, null, 8, ["refresh", "locations", "scenario", "model", "location", "onStartBusy", "onEndBusy"])
                            ])
                          ]),
                          _createElementVNode("section", null, [
                            _createElementVNode("h4", null, _toDisplayString(_ctx.$t("message.catchmentArea") + ' ' + (_ctx.model.catchmentAreaMode == 0 ? _ctx.$t('message.secondary') : '')), 1),
                            _createElementVNode("div", _hoisted_9, [
                              _createVNode(_component_Mapbox, {
                                mapState: { zoom: 11 },
                                report: true,
                                refresh: _ctx.refresh,
                                locationCatchmentArea: _ctx.locationCatchmentArea,
                                scenario: _ctx.scenario,
                                catchmentArea: _ctx.catchmentArea,
                                locations: _ctx.locations,
                                model: _ctx.model,
                                showAreas: true,
                                location: _ctx.location,
                                onStartBusy: _ctx.startBusy,
                                onEndBusy: _ctx.endBusy
                              }, null, 8, ["refresh", "locationCatchmentArea", "scenario", "catchmentArea", "locations", "model", "location", "onStartBusy", "onEndBusy"])
                            ])
                          ]),
                          (_ctx.locationCatchmentArea != null && _ctx.locationCatchmentArea.areas != null && _ctx.locationCatchmentArea.areas.length > 0)
                            ? (_openBlock(), _createElementBlock("section", _hoisted_10, [
                                _createElementVNode("h4", null, _toDisplayString(_ctx.$t("message.top25")) + " " + _toDisplayString(_ctx.$tc("message.areasType" + _ctx.model.areasType + "Name",0).toLowerCase()), 1),
                                _createVNode(_component_v_table, {
                                  density: "compact",
                                  style: {"margin-bottom":"1em"}
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("thead", null, [
                                      _createElementVNode("tr", null, [
                                        _createElementVNode("th", null, _toDisplayString(_ctx.$tc("message.areasType" + _ctx.model.areasType + "Name",1)), 1),
                                        _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.$t("message.share")), 1),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.locationCatchmentArea.areas[0].areaProperties, (areaProperty) => {
                                          return (_openBlock(), _createElementBlock(_Fragment, null, [
                                            (areaProperty.titleShort != null)
                                              ? (_openBlock(), _createElementBlock("th", {
                                                  class: "text-right",
                                                  key: areaProperty.name
                                                }, _toDisplayString(areaProperty.titleShort), 1))
                                              : _createCommentVNode("", true)
                                          ], 64))
                                        }), 256))
                                      ])
                                    ]),
                                    _createElementVNode("tbody", null, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.locationCatchmentArea.areas.slice(0,25), (area) => {
                                        return (_openBlock(), _createElementBlock("tr", {
                                          key: area.areaCode
                                        }, [
                                          _createElementVNode("td", null, _toDisplayString(area.areaCode), 1),
                                          _createElementVNode("td", _hoisted_12, [
                                            (_ctx.model.outputType == 1)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                                                  _createVNode(_component_PropertyValue, {
                                                    property: { numberValue: area.output, dataType: 3 },
                                                    onlyCurrentValue: true
                                                  }, null, 8, ["property"])
                                                ]))
                                              : _createCommentVNode("", true),
                                            (_ctx.model.outputType == 2)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
                                                  _createVNode(_component_PropertyValue, {
                                                    property: { numberValue: area.output, dataType: 1, roundingDigits: 0 },
                                                    onlyCurrentValue: true
                                                  }, null, 8, ["property"])
                                                ]))
                                              : _createCommentVNode("", true),
                                            (_ctx.model.outputType == 3)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
                                                  _createVNode(_component_PropertyValue, {
                                                    property: { numberValue: area.output, dataType: 3 },
                                                    onlyCurrentValue: true
                                                  }, null, 8, ["property"])
                                                ]))
                                              : _createCommentVNode("", true),
                                            (_ctx.model.outputType == 4)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
                                                  _createVNode(_component_PropertyValue, {
                                                    property: { numberValue: area.output, dataType: 1, roundingDigits: 0 },
                                                    onlyCurrentValue: true
                                                  }, null, 8, ["property"])
                                                ]))
                                              : _createCommentVNode("", true)
                                          ]),
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(area.areaProperties, (areaProperty) => {
                                            return (_openBlock(), _createElementBlock(_Fragment, null, [
                                              (areaProperty.titleShort != null)
                                                ? (_openBlock(), _createElementBlock("td", {
                                                    key: areaProperty.name,
                                                    class: "text-right"
                                                  }, [
                                                    _createVNode(_component_PropertyValue, {
                                                      property: {stringValue: areaProperty.stringValue, numberValue: areaProperty.numberValue, dataType: areaProperty.dataType, roundingDigits: areaProperty.roundingDigits},
                                                      onlyCurrentValue: true
                                                    }, null, 8, ["property"])
                                                  ]))
                                                : _createCommentVNode("", true)
                                            ], 64))
                                          }), 256))
                                        ]))
                                      }), 128))
                                    ])
                                  ]),
                                  _: 1
                                })
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.matchingLocations != null && _ctx.matchingLocations.length > 1)
                            ? (_openBlock(), _createElementBlock("section", _hoisted_17, [
                                _createElementVNode("h4", null, _toDisplayString(_ctx.$t("message.matchingLocationsOutputChart")), 1),
                                _createVNode(_component_MatchingLocationsOutputChart, {
                                  matchingLocations: _ctx.matchingLocations,
                                  matchingColors: _ctx.matchingColors,
                                  model: _ctx.model,
                                  style: {"width":"100%","overflow":"hidden"}
                                }, null, 8, ["matchingLocations", "matchingColors", "model"])
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.matchingScores != null && _ctx.matchingScores.length > 1)
                            ? (_openBlock(), _createElementBlock("section", _hoisted_18, [
                                _createElementVNode("h4", null, _toDisplayString(_ctx.$t("message.matchingLocationsSimilarityChart")), 1),
                                _createVNode(_component_MatchingLocationsRadarChart, {
                                  matchingScores: _ctx.matchingScores,
                                  matchingColors: _ctx.matchingColors,
                                  style: {"width":"100%","overflow":"hidden"}
                                }, null, 8, ["matchingScores", "matchingColors"])
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.locationDrivers != null && _ctx.locationDrivers.length > 0)
                            ? (_openBlock(), _createElementBlock("section", _hoisted_19, [
                                _createElementVNode("h4", null, _toDisplayString(_ctx.$t("message.driversChart")), 1),
                                _createVNode(_component_DriversChart, { locationDrivers: _ctx.locationDrivers }, null, 8, ["locationDrivers"])
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("section", null, [
                            _createElementVNode("h4", null, _toDisplayString(_ctx.$t("message.disclaimer")), 1),
                            _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.$t("message.disclaimerContent")), 1)
                          ])
                        ], 64))
                      : _createCommentVNode("", true),
                    (_ctx.model.locationReportFormat)
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(JSON.parse(_ctx.model.locationReportFormat).components, (component, index) => {
                          return (_openBlock(), _createElementBlock(_Fragment, null, [
                            (component.name == 'mapLocations')
                              ? (_openBlock(), _createElementBlock("section", { key: index }, [
                                  _createElementVNode("h4", null, _toDisplayString(_ctx.$t("message.localSituation")), 1),
                                  _createElementVNode("div", _hoisted_21, [
                                    _createVNode(_component_Mapbox, {
                                      report: true,
                                      mapState: { zoom: component.zoom },
                                      refresh: _ctx.refresh,
                                      scenario: _ctx.scenario,
                                      locations: _ctx.locations,
                                      model: _ctx.model,
                                      location: _ctx.location,
                                      onStartBusy: _ctx.startBusy,
                                      onEndBusy: _ctx.endBusy
                                    }, null, 8, ["mapState", "refresh", "scenario", "locations", "model", "location", "onStartBusy", "onEndBusy"])
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (component.name == 'mapCatchmentArea')
                              ? (_openBlock(), _createElementBlock("section", { key: index }, [
                                  _createElementVNode("h4", null, _toDisplayString(_ctx.$t("message.catchmentArea")), 1),
                                  _createElementVNode("div", _hoisted_22, [
                                    _createVNode(_component_Mapbox, {
                                      report: true,
                                      mapState: { zoom: component.zoom },
                                      refresh: _ctx.refresh,
                                      scenario: _ctx.scenario,
                                      locationCatchmentArea: _ctx.locationCatchmentArea,
                                      catchmentArea: _ctx.catchmentArea,
                                      locations: _ctx.locations,
                                      model: _ctx.model,
                                      showAreas: true,
                                      location: _ctx.location,
                                      onStartBusy: _ctx.startBusy,
                                      onEndBusy: _ctx.endBusy
                                    }, null, 8, ["mapState", "refresh", "scenario", "locationCatchmentArea", "catchmentArea", "locations", "model", "location", "onStartBusy", "onEndBusy"])
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (component.name == 'mapCatchmentAreaPrimary')
                              ? (_openBlock(), _createElementBlock("section", { key: index }, [
                                  _createElementVNode("h4", null, _toDisplayString(_ctx.$t("message.catchmentArea") + ' ' + _ctx.$t('message.primary').toLowerCase()), 1),
                                  _createElementVNode("div", _hoisted_23, [
                                    _createVNode(_component_Mapbox, {
                                      mapState: { zoom: component.zoom },
                                      refresh: _ctx.refresh,
                                      scenario: _ctx.scenario,
                                      locationCatchmentArea: _ctx.locationCatchmentArea,
                                      catchmentArea: _ctx.catchmentArea,
                                      locations: _ctx.locations,
                                      model: _ctx.model,
                                      showAreas: true,
                                      location: _ctx.location,
                                      onStartBusy: _ctx.startBusy,
                                      onEndBusy: _ctx.endBusy
                                    }, null, 8, ["mapState", "refresh", "scenario", "locationCatchmentArea", "catchmentArea", "locations", "model", "location", "onStartBusy", "onEndBusy"])
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (component.name == 'mapCatchmentAreaSecondary')
                              ? (_openBlock(), _createElementBlock("section", { key: index }, [
                                  _createElementVNode("h4", null, _toDisplayString(_ctx.$t("message.catchmentArea") + ' ' + _ctx.$t('message.secondary').toLowerCase()), 1),
                                  _createElementVNode("div", _hoisted_24, [
                                    _createVNode(_component_Mapbox, {
                                      report: true,
                                      mapState: { zoom: component.zoom },
                                      refresh: _ctx.refresh,
                                      scenario: _ctx.scenario,
                                      locationCatchmentArea: _ctx.locationCatchmentArea,
                                      catchmentArea: _ctx.catchmentArea,
                                      locations: _ctx.locations,
                                      model: _ctx.model,
                                      showAreas: true,
                                      location: _ctx.location,
                                      onStartBusy: _ctx.startBusy,
                                      onEndBusy: _ctx.endBusy
                                    }, null, 8, ["mapState", "refresh", "scenario", "locationCatchmentArea", "catchmentArea", "locations", "model", "location", "onStartBusy", "onEndBusy"])
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (component.name == 'properties')
                              ? (_openBlock(), _createElementBlock("section", { key: index }, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(component.sections, (section, index2) => {
                                    return (_openBlock(), _createElementBlock("div", { key: index2 }, [
                                      _createVNode(_component_Properties, {
                                        subModel: _ctx.subModel,
                                        model: _ctx.model,
                                        location: _ctx.location,
                                        locationProperties: _ctx.filterItems(_ctx.locationProperties, section)
                                      }, null, 8, ["subModel", "model", "location", "locationProperties"])
                                    ]))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true),
                            (component.name == 'properties2Columns')
                              ? (_openBlock(), _createElementBlock("section", { key: index }, [
                                  _createVNode(_component_v_container, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_row, null, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(component.sectionsLeft, (section, index2) => {
                                            return (_openBlock(), _createBlock(_component_v_col, {
                                              class: "pr-4",
                                              style: {"max-width":"50%"},
                                              key: 'left' + index2
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_Properties, {
                                                  subModel: _ctx.subModel,
                                                  model: _ctx.model,
                                                  location: _ctx.location,
                                                  locationProperties: _ctx.filterItems(_ctx.locationProperties, section)
                                                }, null, 8, ["subModel", "model", "location", "locationProperties"])
                                              ]),
                                              _: 2
                                            }, 1024))
                                          }), 128)),
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(component.sectionsRight, (section, index2) => {
                                            return (_openBlock(), _createBlock(_component_v_col, {
                                              class: "pl-4",
                                              style: {"max-width":"50%"},
                                              key: 'right' + index2
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_Properties, {
                                                  subModel: _ctx.subModel,
                                                  model: _ctx.model,
                                                  location: _ctx.location,
                                                  locationProperties: _ctx.filterItems(_ctx.locationProperties, section)
                                                }, null, 8, ["subModel", "model", "location", "locationProperties"])
                                              ]),
                                              _: 2
                                            }, 1024))
                                          }), 128))
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]))
                              : _createCommentVNode("", true),
                            (component.name == 'topAreas' && _ctx.locationCatchmentArea != null && _ctx.locationCatchmentArea.areas != null && _ctx.locationCatchmentArea.areas.length > 0)
                              ? (_openBlock(), _createElementBlock("section", { key: index }, [
                                  _createElementVNode("h4", null, _toDisplayString(_ctx.$t("message.top")) + " " + _toDisplayString(component.numberOfAreas) + " " + _toDisplayString(_ctx.$tc("message.areasType" + _ctx.model.areasType + "Name",0).toLowerCase()), 1),
                                  _createVNode(_component_v_table, { density: "compact" }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("thead", null, [
                                        _createElementVNode("tr", null, [
                                          _createElementVNode("th", null, _toDisplayString(_ctx.$tc("message.areasType" + _ctx.model.areasType + "Name",1)), 1),
                                          _createElementVNode("th", _hoisted_25, _toDisplayString(_ctx.$t("message.share")), 1),
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.locationCatchmentArea.areas[0].areaProperties, (areaProperty) => {
                                            return (_openBlock(), _createElementBlock(_Fragment, null, [
                                              (areaProperty.titleShort != null)
                                                ? (_openBlock(), _createElementBlock("th", {
                                                    class: "text-right",
                                                    key: areaProperty.name
                                                  }, _toDisplayString(areaProperty.titleShort), 1))
                                                : _createCommentVNode("", true)
                                            ], 64))
                                          }), 256))
                                        ])
                                      ]),
                                      _createElementVNode("tbody", null, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.locationCatchmentArea.areas.slice(0,component.numberOfAreas), (area) => {
                                          return (_openBlock(), _createElementBlock("tr", {
                                            key: area.areaCode
                                          }, [
                                            _createElementVNode("td", null, _toDisplayString(area.areaCode), 1),
                                            _createElementVNode("td", _hoisted_26, [
                                              (_ctx.model.outputType == 1)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_27, [
                                                    _createVNode(_component_PropertyValue, {
                                                      property: { numberValue: area.output, dataType: 3 },
                                                      onlyCurrentValue: true
                                                    }, null, 8, ["property"])
                                                  ]))
                                                : _createCommentVNode("", true),
                                              (_ctx.model.outputType == 2)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_28, [
                                                    _createVNode(_component_PropertyValue, {
                                                      property: { numberValue: area.output, dataType: 1, roundingDigits: 0 },
                                                      onlyCurrentValue: true
                                                    }, null, 8, ["property"])
                                                  ]))
                                                : _createCommentVNode("", true),
                                              (_ctx.model.outputType == 3)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_29, [
                                                    _createVNode(_component_PropertyValue, {
                                                      property: { numberValue: area.output, dataType: 3 },
                                                      onlyCurrentValue: true
                                                    }, null, 8, ["property"])
                                                  ]))
                                                : _createCommentVNode("", true),
                                              (_ctx.model.outputType == 4)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_30, [
                                                    _createVNode(_component_PropertyValue, {
                                                      property: { numberValue: area.output, dataType: 1, roundingDigits: 0 },
                                                      onlyCurrentValue: true
                                                    }, null, 8, ["property"])
                                                  ]))
                                                : _createCommentVNode("", true)
                                            ]),
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(area.areaProperties, (areaProperty) => {
                                              return (_openBlock(), _createElementBlock(_Fragment, null, [
                                                (areaProperty.titleShort != null)
                                                  ? (_openBlock(), _createElementBlock("td", {
                                                      key: areaProperty.name,
                                                      class: "text-right"
                                                    }, [
                                                      _createVNode(_component_PropertyValue, {
                                                        property: {stringValue: areaProperty.stringValue, numberValue: areaProperty.numberValue, dataType: areaProperty.dataType, roundingDigits: areaProperty.roundingDigits},
                                                        onlyCurrentValue: true
                                                      }, null, 8, ["property"])
                                                    ]))
                                                  : _createCommentVNode("", true)
                                              ], 64))
                                            }), 256))
                                          ]))
                                        }), 128))
                                      ])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]))
                              : _createCommentVNode("", true),
                            (component.name == 'matchingLocations' && _ctx.matchingLocations != null && _ctx.matchingLocations.length > 1)
                              ? (_openBlock(), _createElementBlock("section", { key: index }, [
                                  _createElementVNode("h4", null, _toDisplayString(_ctx.$t("message.matchingLocationsOutputChart")), 1),
                                  _createVNode(_component_MatchingLocationsOutputChart, {
                                    matchingLocations: _ctx.matchingLocations,
                                    matchingColors: _ctx.matchingColors,
                                    model: _ctx.model,
                                    style: {"width":"100%","overflow":"hidden"}
                                  }, null, 8, ["matchingLocations", "matchingColors", "model"])
                                ]))
                              : _createCommentVNode("", true),
                            (component.name == 'matchingScores' && _ctx.matchingScores != null && _ctx.matchingScores.length > 1)
                              ? (_openBlock(), _createElementBlock("section", { key: index }, [
                                  _createElementVNode("h4", null, _toDisplayString(_ctx.$t("message.matchingLocationsSimilarityChart")), 1),
                                  _createVNode(_component_MatchingLocationsRadarChart, {
                                    matchingScores: _ctx.matchingScores,
                                    matchingColors: _ctx.matchingColors,
                                    style: {"width":"100%","overflow":"hidden"}
                                  }, null, 8, ["matchingScores", "matchingColors"])
                                ]))
                              : _createCommentVNode("", true),
                            (component.name == 'drivers' && _ctx.locationDrivers != null && _ctx.locationDrivers.length > 0)
                              ? (_openBlock(), _createElementBlock("section", { key: index }, [
                                  _createElementVNode("h4", null, _toDisplayString(_ctx.$t("message.driversChart")), 1),
                                  _createVNode(_component_DriversChart, { locationDrivers: _ctx.locationDrivers }, null, 8, ["locationDrivers"])
                                ]))
                              : _createCommentVNode("", true),
                            (component.name == 'disclaimer')
                              ? (_openBlock(), _createElementBlock("section", { key: index }, [
                                  _createElementVNode("h4", null, _toDisplayString(_ctx.$t("message.disclaimer")), 1),
                                  _createElementVNode("p", _hoisted_31, _toDisplayString(_ctx.$t("message.disclaimerContent")), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (component.name == 'textSection')
                              ? (_openBlock(), _createElementBlock("section", { key: index }, [
                                  _createElementVNode("h4", null, _toDisplayString(component.title), 1),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(component.paragraphs, (paragraph, index) => {
                                    return (_openBlock(), _createElementBlock("p", {
                                      key: index,
                                      class: _normalizeClass(paragraph.class)
                                    }, _toDisplayString(paragraph.content), 3))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true)
                          ], 64))
                        }), 256))
                      : _createCommentVNode("", true),
                    _createElementVNode("p", _hoisted_32, _toDisplayString(_ctx.model.name) + " (" + _toDisplayString(_ctx.model.id) + "/" + _toDisplayString(_ctx.scenario.id) + "/" + _toDisplayString(_ctx.location.id) + ") " + _toDisplayString(_ctx.environment == 'Production' ? '' : _ctx.environment), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_actions, { class: "d-print-none" }, {
                  default: _withCtx(() => [
                    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "flex-grow-1" }, null, -1)),
                    _createVNode(_component_v_btn, {
                      onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.Window.print();}),
                      color: "primary",
                      variant: "text"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("message.print")), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_btn, {
                      color: "primary",
                      variant: "text",
                      onClick: _ctx.close
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("message.cancel")), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}